import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, EventEmitter,
  Input,
  OnInit, Output
} from '@angular/core';
import {FormControl} from '@angular/forms';
import {BaseComponent, FileService} from 'compob2b-libs';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, startWith, tap} from 'rxjs/operators';
import {Executor, ExecutorAutocompleteStore, IssueExecutor} from "../executor-autocomplete.store";

@Component({
    selector: 'app-executor-multiple-autocomplete',
    templateUrl: './executor-multiple-autocomplete.template.html',
    styleUrls: ['executor-multiple-autocomplete.styles.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ExecutorMultipleAutocompleteComponent extends BaseComponent implements OnInit, AfterViewInit {
  @Input() initialEntities: IssueExecutor[] = [];
  @Input() excludeEntity: IssueExecutor;
  @Output() changeEvent = new EventEmitter<Executor[]>();

  excludeEntityIds: number[] = [];
  entityControl = new FormControl([]);
  loading = true;
  entities: Executor[];
  values: Executor[];
  entityInput$ = new Subject<string>();

  constructor(public readonly store: ExecutorAutocompleteStore,
              private readonly fileService: FileService
  ) {
    super();
  }

  ngAfterViewInit(): void {
    this.store.load();
    this.entityInput$
      .pipe(
        startWith(''),
        debounceTime(300),
        distinctUntilChanged(),
        tap(keyword => this.store.filter(keyword))
      ).subscribe();

  }

  ngOnInit(): void {
    this.initValues();
    this.store.items$.subscribe(_ => {
      this.loading = false;
      this.entities = _.filter(item => !this.excludeEntityIds.includes(item.id));
      this.cdr.markForCheck();
    });
  }


  private initValues() {
    this.entityControl.setValue(!!this.initialEntities ? this.initialEntities.map(value => this.createExecutor(value)) : []);
    this.excludeEntityIds = this.entityControl.value.map((_: Executor) => _.id);
    if (!!this.excludeEntity) {
      this.excludeEntityIds.push(this.excludeEntity.id);
    }
    this.cdr.markForCheck();
  }

  compareEntities(a: Executor, b: Executor): boolean {
    return a.id === b.id;
  }

  clearValues(): void {
    this.entityControl.setValue([]);
    this.excludeEntityIds = [];
    this.changeEvent.emit([]);
  }

  removeValue(executor: Executor): void {
    this.excludeEntityIds = this.excludeEntityIds.filter(item => item !== executor.id);
    const values = this.entityControl.value.filter((item: Executor) => item.id !== executor.id);
    this.entityControl.setValue(values);
    this.changeEvent.emit(values);
    this.cdr.markForCheck();
  }

  addValue(value: Executor): void {
    this.excludeEntityIds.push(value.id);
    this.changeEvent.emit(this.entityControl.value);
  }

  getImageSrc(picture: string): string {
    return picture === null ? null : this.fileService.getImageSrc(picture, 96);
  }

  private createExecutor(assignee: IssueExecutor): Executor {
    return !!assignee ? {
      id: assignee.id,
      header: assignee.firstName + ' ' + assignee.lastName,
      picture: assignee.picture ? assignee.picture.name + '.' + assignee.picture.type : null
    } : this.emptyAssignee;
  }

  get emptyAssignee() {
    return {id: 0, header: 'Не назначено', picture: null};
  }
}
